import React from 'react'
import './MenuEstancias.css'

import { connect } from 'react-redux'
import {
  getAcabados,
  getEstanciaActualTitle,
  setHeightViewport,
  getSubtotal,
  getTotal,
  getEndMenu
} from '../../modules/reducer'

import Acabado from './Acabado'
import MenuSlider from './MenuSlider'

import MenuScroll from './MenuScroll'
import MenuTotales from './MenuTotales'

import MeasureHeight from './MeasureHeight'

import { setPositionY } from './MenuScroll'

const MenuEstancias = ({
  estanciaTitle,
  acabados,
  subtotal,
  total,
  setHeightViewport,
  showSlider,
  heightHeader
}) => {
  const padding = 20

  const mq = window.matchMedia('(max-width: 823px)')

  let ocultSlider = false

  if (mq.matches) {
    ocultSlider = true
  }

  const mq1 = window.matchMedia('(max-width: 420px)')

  let marginTop = 0

  if (mq1.matches) {
    marginTop = 257
  }

  let display = 'block'
  let visibleSlider = true

  if (ocultSlider) {
    display = 'none'
    visibleSlider = false
    setPositionY(0)
  } else if (showSlider) {
    display = 'block'
    visibleSlider = true
  } else {
    display = 'none'
    visibleSlider = false
    setPositionY(0)
  }

  return (
    <div
      className="col-3_sm-12_md-4 grid-column-noGutter"
      style={{ marginTop }}
    >
      <div className="col-12" style={{ paddingLeft: padding }}>
        <h1>{estanciaTitle}</h1>
      </div>
      <div className="menu-viewport col-12 grid-noGutter">
        <MeasureHeight setSize={setHeightViewport} />

        <MenuScroll>
          {acabados.map(idAcabado => (
            <Acabado key={idAcabado} id={idAcabado} padding={padding} />
          ))}
        </MenuScroll>

        <div className="col-1 sm-hidden" style={{ height: '100%', display }}>
          <MenuSlider visible={visibleSlider} />
        </div>
      </div>

      <MenuTotales padding={padding} />
    </div>
  )
}

const mapStateToProps = ({ reducer }, ownProps) => {
  const endMenu = getEndMenu(reducer)

  return {
    estanciaTitle: getEstanciaActualTitle(reducer),
    acabados: getAcabados(reducer),
    subtotal: getSubtotal(reducer),
    total: getTotal(reducer),
    showSlider: endMenu < 0,
    heightHeader: reducer.heightHeader
  }
}

const mapDispatchToProps = { setHeightViewport }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuEstancias)
